var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box grow verification-code",domProps:{"innerHTML":_vm._s(_vm.captcha)},on:{"click":_vm.getCaptcha}})}
var staticRenderFns = []

export { render, staticRenderFns }